import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext.js';
import { FeatureTourProvider, FeatureTourBanner } from './FeatureTour.js';

const AdminLayout = () => {
  const { user, signOut, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    navigate('/portal/login', { replace: true });
  };

  const navLinkClass = ({ isActive }) =>
    `block px-4 py-2 rounded-md text-sm font-medium transition-colors ${
      isActive
        ? 'bg-green-700 text-white'
        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
    }`;

  return (
    <FeatureTourProvider>
    <div className="min-h-screen bg-gray-900 flex">
      {/* Mobile sidebar toggle */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-gray-700 text-white rounded-md"
        aria-label="Toggle sidebar"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-40 w-60 bg-gray-900 border-r border-gray-700 flex flex-col transition-transform lg:translate-x-0 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="p-4 border-b border-gray-700">
          <h2 className="text-lg font-bold text-white">Boultbee Portal</h2>
          <p className="text-xs text-gray-400 mt-0.5">Route Planning</p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          <NavLink to="/portal/booked" className={navLinkClass} onClick={() => setSidebarOpen(false)}>
            Booked Work
          </NavLink>
          <NavLink to="/portal/routes" className={navLinkClass} onClick={() => setSidebarOpen(false)}>
            Routes
          </NavLink>
          <NavLink to="/portal/import" className={navLinkClass} onClick={() => setSidebarOpen(false)}>
            Import CSV
          </NavLink>
          {isAdmin && (
            <NavLink to="/portal/team" className={navLinkClass} onClick={() => setSidebarOpen(false)}>
              Team
            </NavLink>
          )}
          <NavLink to="/portal/payroll" className={navLinkClass} onClick={() => setSidebarOpen(false)}>
            Time
          </NavLink>
          <NavLink to="/portal/guide" className={navLinkClass} onClick={() => setSidebarOpen(false)}>
            Guide
          </NavLink>
        </nav>

        <div className="p-4 border-t border-gray-700 space-y-2">
          <p className="text-xs text-gray-400 truncate">{user?.email}</p>
          <NavLink
            to="/portal/profile"
            className="block text-xs text-gray-300 hover:text-white transition-colors"
            onClick={() => setSidebarOpen(false)}
          >
            Edit Profile / Home Base
          </NavLink>
          <button
            onClick={handleSignOut}
            className="w-full text-left text-sm text-gray-300 hover:text-white transition-colors"
          >
            Sign Out
          </button>
        </div>
      </aside>

      {/* Overlay for mobile sidebar */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-gray-900 bg-opacity-50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main content */}
      <main className="flex-1 lg:ml-60 min-w-0">
        <div className="p-4 sm:p-6 pt-14 lg:pt-6">
          <FeatureTourBanner />
          <Outlet />
        </div>
      </main>
    </div>
    </FeatureTourProvider>
  );
};

export default AdminLayout;
